// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "25d2f3c6" + "." + "d478dcc9ea3edeed" + ".js";
};